import { render } from "./PreventivoFirmatoBox.vue?vue&type=template&id=77abca90&scoped=true"
import script from "./PreventivoFirmatoBox.vue?vue&type=script&lang=js"
export * from "./PreventivoFirmatoBox.vue?vue&type=script&lang=js"

import "./PreventivoFirmatoBox.vue?vue&type=style&index=0&id=77abca90&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77abca90"]])

export default __exports__